<template lang="pug">
  v-card
    v-toolbar.elevation-0(height="45" color="gray")
      v-toolbar-title
        h1.subheading Ticket Status
    v-card-text(v-if="isLoading")
      v-progress-linear( size="70" color="pink" width="7" indeterminate)
    v-list(v-if="!isLoading")
      template(v-for="(row, index) in ticketStatusCount" v-if="row.id !== 50")
        v-list-tile(:key="row.id" avatar ripple @click="openTicketList(row.id)")
          v-list-tile-content
            v-list-tile-title {{ row.selector }}
          v-list-tile-action
            div.subheading {{ row.total }}
        v-divider(v-if="index + 1 < ticketStatusCount.length" :key="index") 
</template>

<script>
import taskService from '../service.js'
export default {
data() {
    return {
      ticketStatusCount: [],
      isLoading: true
    }
  },
  methods: {
    openTicketList(data) {
      this.$router.push({name: 'ticket-list', params: {status: data}})
    },
    formatToNumber(value) {
      return `${value.toFixed(0)}`;
    },
    getAllTicketCount() {
      taskService.getAllTicketCount()
      .then(result => {
        console.log('dfdfd', result)
        this.ticketStatusCount = result.data.ticketStatusCount
        this.isLoading = false
      })
    },
  },
  mounted() {
    this.getAllTicketCount()
  }
}
</script>

<style scoped>
</style>